import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconTrashOutline = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-label="IconTrashOutline"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path d="M4.86 24a2.27 2.27 0 0 1-1.64-.7 2.21 2.21 0 0 1-.708-1.622V3.4h-.354a1.1 1.1 0 0 1-.82-.35A1.15 1.15 0 0 1 1 2.224a1.1 1.1 0 0 1 .338-.81 1.12 1.12 0 0 1 .82-.335H7.69A1 1 0 0 1 8.028.3c.225-.2.519-.307.82-.3h6.272c.302-.007.595.1.82.3a1 1 0 0 1 .338.78h5.532c.312-.004.613.116.836.333a1.07 1.07 0 0 1 .354.811 1.1 1.1 0 0 1-.354.842 1.18 1.18 0 0 1-.836.334h-.354v18.278a2.21 2.21 0 0 1-.708 1.621 2.27 2.27 0 0 1-1.64.7zm0-20.6v18.278h14.248V3.4zm3.152 14.37a1.1 1.1 0 0 0 .338.81 1.12 1.12 0 0 0 .82.334c.312.004.613-.116.836-.334a1.07 1.07 0 0 0 .354-.81V7.277a1.12 1.12 0 0 0-.354-.826 1.15 1.15 0 0 0-.836-.35 1.1 1.1 0 0 0-.82.35 1.15 1.15 0 0 0-.338.826zm5.63 0a1.1 1.1 0 0 0 .337.81 1.13 1.13 0 0 0 .82.334c.312.004.613-.116.836-.334a1.07 1.07 0 0 0 .354-.81V7.277a1.12 1.12 0 0 0-.354-.826 1.15 1.15 0 0 0-.836-.35 1.1 1.1 0 0 0-.82.35 1.15 1.15 0 0 0-.338.826z" />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconTrashOutline);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
